var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ImageConverter_1;
import { injectable } from 'inversify';
import { HttpService } from '../http';
import { FileType } from '../file-type';
let ImageConverter = ImageConverter_1 = class ImageConverter {
    constructor(http, fileType) {
        this.http = http;
        this.fileType = fileType;
    }
    convert(image) {
        return __awaiter(this, void 0, void 0, function* () {
            const detectedType = yield this.fileType.fileTypeFromBlob(image);
            const imageType = detectedType !== null && detectedType !== void 0 ? detectedType : image.type;
            if (imageType === 'image/jpeg') {
                return image;
            }
            if (!ImageConverter_1.SUPPORTED_TYPES.includes(imageType)) {
                throw new Error('Неподдерживаемый тип изображения');
            }
            const result = yield this.http.generateFile('/tools/image/convert', {
                image,
            });
            return result;
        });
    }
};
ImageConverter.SUPPORTED_TYPES = [
    'image/heic',
    'image/heif',
    'image/tiff',
    'image/dng',
    'image/x-adobe-dng',
];
ImageConverter = ImageConverter_1 = __decorate([
    injectable(),
    __metadata("design:paramtypes", [HttpService,
        FileType])
], ImageConverter);
export { ImageConverter };
